import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/goz-alti-isik-dolgusuna-uygunluk-kimler-icin-ideal-kimler-icin-degil/page.tsx");
